// extracted by mini-css-extract-plugin
module.exports = {"headName":"header_headName__1Tym0"};